















































































































import { createComponent } from '@vue/composition-api';

import UIInput from '@sbvr/common/legacy-shared/components/ui/UIInput.vue';
import Loading from '@sbvr/common/legacy-shared/components/Loading.vue';
import UIButton from '@sbvr/common/legacy-shared/components/ui/UIButton.vue';
import UIRowIndexLoader from '@sbvr/common/legacy-shared/components/ui/UIRowIndexLoader.vue';

import DeviceGroup from '@/core/store/types/DeviceGroup';
import DeviceStatus from '@/devices/components/DeviceStatus.vue';
import { useRouter } from '@/core/routes';

export default createComponent({
  props: {
    searchQuery: {
      type: String,
      required: true,
    },
    searchLoading: {
      type: Boolean,
      required: true,
    },
    filteredDeviceGroups: {
      type: Array as () => DeviceGroup[],
      required: true,
    },
  },
  components: {
    UIInput,
    UIButton,
    UIRowIndexLoader,
    Loading,
    DeviceStatus,
  },
  setup (props, { emit }) {
    const router = useRouter();

    function navigateToDeviceGroupShow (event: Event, deviceGroupId: string): void {
      event.stopPropagation();
      router.push({
        name: 'device-group-show',
        params: { deviceGroupId },
      });
    }

    function toggleDeviceGroup (event: Event, deviceGroup: DeviceGroup): void {
      if (deviceGroup.deviceCount === 0) return;
      emit('toggleDeviceGroup', deviceGroup.id);
      window.getSelection()?.empty();
    }

    return {
      navigateToDeviceGroupShow,
      toggleDeviceGroup,
    };
  },
});
